import { jwtDecode } from "jwt-decode";

interface JwtPayload {

    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier": string;

    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name": string;

    "http://schemas.microsoft.com/ws/2008/06/identity/claims/role": string;

    exp: number;

}

const getToken = () => {

    return localStorage.getItem("token");

};

const getClaims = (): JwtPayload | null => {

    const token = getToken();

    if (!token)
        return null;

    try {

        return jwtDecode<JwtPayload>(token);

    }
    catch {

        return null;

    }

};

const getUserId = () => {

    return getClaims()?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ];

};

const getUserName = () => {

    return getClaims()?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
    ];

};

const getRole = () => {

    return getClaims()?.[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
    ];

};

const isLoggedIn = () => {

    return !!getToken();

};

export default {

    getToken,

    getClaims,

    getUserId,

    getUserName,

    getRole,

    isLoggedIn

};